export type SortDirection = 'asc' | 'desc' | null;

export interface SortState {
  columnKey: string | null;
  direction: SortDirection;
}

export const UNSORTED: SortState = { columnKey: null, direction: null };

export interface SortableColumn {
  key: string;
  label: string;
  sortable?: boolean;
}

export interface LegacySortParams {
  sort_by: string | null;
  sort_order: 'asc' | 'desc' | null;
}

export type ColumnKeyMap = Record<string, string>;

export interface SortStorageKeyParts {
  table: string;
  variant?: string;
  context?: string;
}
